import {
  IS_STAGING,
  LIXI_BAG,
  LIXI_NFT,
  BSC_SCAN,
  SOLANA_RPC_URL,
  SOLANA_PROGRAM_ID,
  SOLANA_CLUSTER,
  SOLANA_AUTHORITY,
  DEFAULT_CHAIN,
  SUPPORTED_CHAINS,
  type SupportedChain,
} from '../constants';

export interface ChainConfig {
  id: string;
  name: string;
  symbol: string;
  decimals: number;
  rpcUrl: string;
  explorerUrl: string;
  contractAddress?: string;
  programId?: string;
  authority?: string;
  cluster?: string;
  isTestnet: boolean;
}

export interface ChainConfigs {
  bnb: ChainConfig;
  solana: ChainConfig;
}

export const CHAIN_CONFIG: ChainConfigs = {
  bnb: {
    id: 'bnb',
    name: IS_STAGING === 'true' ? 'BSC Testnet' : 'BSC Mainnet',
    symbol: IS_STAGING === 'true' ? 'tBNB' : 'BNB',
    decimals: 18,
    rpcUrl:
      IS_STAGING === 'true'
        ? 'https://bsc-testnet-rpc.publicnode.com'
        : 'https://bsc-dataseed1.binance.org',
    explorerUrl: BSC_SCAN,
    contractAddress: LIXI_BAG,
    isTestnet: IS_STAGING === 'true',
  },
  solana: {
    id: 'solana',
    name: SOLANA_CLUSTER === 'devnet' ? 'Solana Devnet' : 'Solana Mainnet',
    symbol: 'SOL',
    decimals: 9,
    rpcUrl: SOLANA_RPC_URL,
    explorerUrl:
      SOLANA_CLUSTER === 'devnet'
        ? 'https://explorer.solana.com/?cluster=devnet'
        : 'https://explorer.solana.com',
    programId: SOLANA_PROGRAM_ID,
    authority: SOLANA_AUTHORITY,
    cluster: SOLANA_CLUSTER,
    isTestnet: SOLANA_CLUSTER === 'devnet',
  },
};

export const getChainConfig = (chain: SupportedChain): ChainConfig => {
  return CHAIN_CONFIG[chain];
};

export const getCurrentChainConfig = (): ChainConfig => {
  return getChainConfig(DEFAULT_CHAIN as SupportedChain);
};

export const isChainSupported = (chain: string): chain is SupportedChain => {
  return SUPPORTED_CHAINS.includes(chain as SupportedChain);
};

export const getChainByNetworkId = (
  networkId: number,
): SupportedChain | null => {
  if (networkId === 56 || networkId === 97) return 'bnb';
  return null;
};

export const getNetworkIdByChain = (chain: SupportedChain): number | null => {
  if (chain === 'bnb') {
    return IS_STAGING === 'true' ? 97 : 56;
  }
  return null;
};
